import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_SEARCH_RESULT_COUNT,
  DEFAULT_SELECTED_PAGE_INDEX,
  DATA_LOAD_STATUS,
} from "../../constants/metaData";

const extractValue = (payload) =>
  payload !== null && payload !== ""
    ? payload.value !== null
      ? payload.value
      : []
    : [];

const initialState = {
  "@odata.context": null,
  value: [],
  searchResultCount: DEFAULT_SEARCH_RESULT_COUNT,
  selectedPageIndex: DEFAULT_SELECTED_PAGE_INDEX,
  selectedIfsDocuments: [],
  selectedIfsDocumentCount: 0,
  enableSpinner: false,
  spinnerText: "",
  versionData: {},
  envData: "",
  error: {},
  downloadData: "",
  documentSearchProgress: DATA_LOAD_STATUS.onStart,
  activeButton: null,
};

const filteredListSlice = createSlice({
  name: "filteredDocuments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_SEARCH_Filtered", (state, action) => {
        state.value = extractValue(action.payload);
      })
      .addCase("SET_INITIAL_VALUE", (state) => {
        state.value = [];
        state.searchResultCount = -1;
      })
      .addCase("ON_IFS_DOCUMENTS_SELECTED", (state, action) => {
        const payload = action.payload;
        if (payload !== undefined && payload !== null) {
          state.selectedIfsDocuments = payload;
          state.selectedIfsDocumentCount = payload.length;
        } else {
          state.selectedIfsDocuments = [];
          state.selectedIfsDocumentCount = 0;
        }
      })
      .addCase("GET_RECENT_DOCUMENT_BY_USER", (state, action) => {
        state.value = action.payload.value;
      })
      .addCase("ON_SEARCH_RESULT_COUNT_CHANGE", (state, action) => {
        const payload = action.payload;
        state.searchResultCount =
          payload !== ""
            ? payload.value !== null
              ? payload.value?.length ?? 0
              : 0
            : 0;
      })
      .addCase("ON_IFS_SEARCH_RESULT_COUNT_CHANGE", (state, action) => {
        state.searchResultCount = action.payload !== null ? action.payload : 0;
      })
      .addCase("ON_SELECTED_PAGE_INDEX_CHANGE", (state, action) => {
        state.selectedPageIndex = action.payload;
      })
      .addCase("ON_PAGE_CHANGE", (state, action) => {
        state.value = action.payload;
      })
      .addCase("ON_SET_DOCUMENT_INITIAL_STATE", (state, action) => {
        state.value = action.payload;
        state.searchResultCount = 0;
        state.selectedPageIndex = 0;
      })
      .addCase("ON_DOWNLOAD_CLICK", (state, action) => {
        const p = action.payload;
        state.spinnerText = p.text;
        state.error = p.error;
      })
      .addCase("ON_GENERATING_COPY_LINKS", (state, action) => {
        const p = action.payload;
        state.spinnerText = p.text;
        state.enableSpinner = p.state;
        state.error = p.error;
      })
      .addCase("ON_DOCUMENT_DOWNLOAD", (state, action) => {
        state.enableSpinner = action.payload;
        if (action.payload !== true) state.spinnerText = "";
      })
      .addCase("ON_SET_VERSION_DETAILS", (state, action) => {
        state.versionData = action.payload;
      })
      .addCase("ON_SET_IFS_ENV_DETAILS", (state, action) => {
        state.envData = action.payload;
        state.error = action.payload.error;
      })
      .addCase("ON_VIWE_DOCUMENT_WEB", (state, action) => {
        const p = action.payload;
        state.spinnerText = p.text;
        state.enableSpinner = p.state;
        state.error = p.error;
      })
      .addCase("ON_SPINNER_TEXT_CHANGE", (state, action) => {
        state.spinnerText = action.payload;
      })
      .addCase("ON_IFS_DOCUMENT_LOAD_CHANGED", (state, action) => {
        state.documentSearchProgress = action.payload;
      })
      .addCase("SET_ACTIVE_BUTTON", (state, action) => {
        state.activeButton = action.payload;
      });
  },
});

export default filteredListSlice;
